export default __webpack_public_path__ + "static/media/ava-05.e1ddc0dd.png";